module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "book"
  }, [_c('div', {
    staticClass: "coverInfo"
  }, [_c('img', {
    staticClass: "coverImage",
    attrs: {
      "src": "//textcafe.co/books/14RZEOW/tc-custom/FC-9781645759225.jpg?1692135021074?1719602156793",
      "alt": "This image is the cover for the book Sole to Soul"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "bookInfo"
  }, [_c('h1', {
    staticClass: "bookTitle heading font1"
  }, [_vm._v("Sole to Soul\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "bookDescription body article font2"
  }), _c('p', [_vm._v("Young Jaxon's mother, a high-end call girl, is murdered in Kansas City. The case has gone cold for several years until Janet, a woman across the state in Saint Louis, receives the shoes that the call girl died in.")]), _c('p', [_vm._v("Jaxon later receives a pair of World War II German military boots on his 11th birthday. He and Janet experience years of flashbacks and memories from the people that originally wore the shoes and boots. They experience the lives of the deceased owners of the shoes.")]), _c('p', [_vm._v("Who killed Jaxon's mom? Why was she murdered? Who benefited from her death? How is everyone and everything connected through four generations? How does the soldier's life teach Jaxon about living, loving and courage while preparing him for a dramatic change in his own life?")]), _c('p', [_c('em', [_vm._v("Sole to Soul")]), _vm._v(" connects the dots between the perils of war and an uncertain future.")]), _vm._v(" "), _c('p')]), _vm._v(" "), _c('div', {
    staticClass: "authorInfo"
  }, [_c('h2', {
    staticClass: "authorName heading font1"
  }, [_vm._v("\n      Gregory S. Hudson\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "authorDescription body article"
  }), _c('p', {
    staticStyle: {
      "margin-top": "0cm",
      "margin-right": "0cm",
      "margin-bottom": ".0001pt",
      "margin-left": "0cm",
      "font-size": "15px",
      "font-family": "\"Calibri\",sans-serif",
      "text-align": "justify"
    }
  }, [_c('span', {
    staticStyle: {
      "font-family": "\"Times New Roman\",serif"
    }
  }, [_vm._v("Gregory S. Hudson, author and professional photographer, has spent years traveling the world, photographing people, places, and cultures. It is wonderful to explore and listen to people talk about their lives and the history that brings them to where they are today. His first book, ")]), _c('em', [_c('span', {
    staticStyle: {
      "font-family": "\"Times New Roman\",serif"
    }
  }, [_vm._v("Through My Eyes")])]), _c('span', {
    staticStyle: {
      "font-family": "\"Times New Roman\",serif"
    }
  }, [_vm._v(", chronicles his travels through photos and famous quotes. Gregory Hudson is the world leading author and creator of Amazon’s book series called Gag Gift Book Series by G Hud. The Gag Gift Book series is a comedy series of dozens of books with bizarre titles. The Gag Gift Books are literally bought and given as gifts because of their titles.")])]), _c('p', {
    staticStyle: {
      "margin-top": "0cm",
      "margin-right": "0cm",
      "margin-bottom": ".0001pt",
      "margin-left": "0cm",
      "font-size": "15px",
      "font-family": "\"Calibri\",sans-serif",
      "text-align": "justify"
    }
  }, [_c('br')]), _c('p', {
    staticStyle: {
      "margin-top": "0cm",
      "margin-right": "0cm",
      "margin-bottom": ".0001pt",
      "margin-left": "0cm",
      "font-size": "15px",
      "font-family": "\"Calibri\",sans-serif",
      "text-align": "justify"
    }
  }, [_c('span', {
    staticStyle: {
      "font-family": "\"Times New Roman\",serif"
    }
  }, [_vm._v("The people Gregory has met along his journey have been inspirational in bringing this story to light. He now spends half of his time at his Puerto Rico home as well as his home in a pleasant little river town called Ironton, along the Ohio River in Ohio.")])]), _c('p', {
    staticStyle: {
      "margin-top": "0cm",
      "margin-right": "0cm",
      "margin-bottom": ".0001pt",
      "margin-left": "0cm",
      "font-size": "15px",
      "font-family": "\"Calibri\",sans-serif",
      "text-align": "justify"
    }
  }, [_c('br')]), _c('p', {
    staticStyle: {
      "margin-top": "0cm",
      "margin-right": "0cm",
      "margin-bottom": ".0001pt",
      "margin-left": "0cm",
      "font-size": "15px",
      "font-family": "\"Calibri\",sans-serif",
      "text-align": "justify"
    }
  }, [_c('span', {
    staticStyle: {
      "font-family": "\"Times New Roman\",serif"
    }
  }, [_vm._v("“I")]), _c('span', {
    staticStyle: {
      "font-family": "\"Times New Roman\",serif"
    }
  }, [_vm._v(" wanted this story to be a mixture of true events and fictional events. I believe this blend enhances the story and characters in a way that most people can relate to.”")])]), _c('p')]), _vm._v(" "), _c('div', {
    staticClass: "publisherInfo"
  }, [_c('h2', {
    staticClass: "publisherName heading font1"
  }, [_vm._v("\n    Austin Macauley Publishers\n   ")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-5610da35","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/home.vue
// module id = 51
// module chunks = 0